import { render, staticRenderFns } from "./TransferenciasExportacion.vue?vue&type=template&id=0a4cd38b&scoped=true"
import script from "./TransferenciasExportacion.vue?vue&type=script&lang=ts"
export * from "./TransferenciasExportacion.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasExportacion.vue?vue&type=style&index=0&id=0a4cd38b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4cd38b",
  null
  
)

export default component.exports